module.exports = __webpack_public_path__ + "img/hk-icon-black.239acbb0.png";